var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.detailInfo),function(item){return [_c('DetailInfo',{key:item.id,attrs:{"formLayout":_vm.changeDetailInfo(item),"columnNum":2}}),_c('a-divider')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }